(function () {
  'use strict';

  function initChatWidget() {
  var root = document.getElementById('pc-chat-root');
  if (!root) return;

  var API_URL = root.dataset.api;
  var TOKEN = root.dataset.token;
  var SHOP_DOMAIN = root.dataset.shopDomain || window.location.hostname;
  var LOCALE = root.dataset.locale || document.documentElement.lang || navigator.language || 'en-US';
  var fab = document.getElementById('pc-chat-fab');
  var panel = document.getElementById('pc-chat-panel');
  var closeBtn = document.getElementById('pc-chat-close');
  var welcomeEl = document.getElementById('pc-chat-welcome');
  var messagesEl = document.getElementById('pc-chat-messages');
  var inputEl = document.getElementById('pc-chat-input');
  var sendBtn = document.getElementById('pc-chat-send');
  var presetBtns = document.querySelectorAll('.pc-chat-preset');

  var loading = false;
  var activeAbort = null;
  var chatStarted = false;

  function createUuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var random = Math.floor(Math.random() * 16);
      var value = character === 'x' ? random : (random & 3) | 8;
      return value.toString(16);
    });
  }

  function getOrCreateId(storage, key, prefix) {
    try {
      var existing = storage.getItem(key);
      if (existing) return existing;

      var created = prefix + createUuid();
      storage.setItem(key, created);
      return created;
    } catch (error) {
      return prefix + createUuid();
    }
  }

  var sessionId = getOrCreateId(window.sessionStorage, 'pettichat_chat_session_id', '');
  var visitorId = getOrCreateId(window.localStorage, 'pettichat_chat_visitor_id', 'shopify-');

  function isPanelOpen() {
    return !panel.hidden;
  }

  function togglePanel(open) {
    panel.hidden = !open;
  }

  function scrollBottom() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function showWelcome() {
    if (chatStarted) return;
    welcomeEl.hidden = false;
    messagesEl.hidden = true;
  }

  function hideWelcome() {
    chatStarted = true;
    welcomeEl.hidden = true;
    messagesEl.hidden = false;
  }

  function renderBotMarkdown(textEl, markdown) {
    if (!markdown) {
      textEl.textContent = '';
      return;
    }
    if (typeof marked === 'undefined') {
      textEl.textContent = markdown;
      return;
    }
    var html = marked.parse(markdown, { breaks: true, gfm: true });
    if (typeof DOMPurify !== 'undefined') {
      html = DOMPurify.sanitize(html);
    }
    textEl.innerHTML = html;
  }

  function setBotPlainText(bot, text) {
    bot.rawMarkdown = '';
    bot.textEl.textContent = text;
    markBotHasText(bot.wrap);
  }

  function appendUserMessage(text) {
    var wrap = document.createElement('div');
    wrap.className = 'pc-chat-msg pc-chat-msg--user';
    var bubble = document.createElement('div');
    bubble.className = 'pc-chat-msg__bubble';
    bubble.textContent = text;
    wrap.appendChild(bubble);
    messagesEl.appendChild(wrap);
    scrollBottom();
  }

  function appendBotPending() {
    var wrap = document.createElement('div');
    wrap.className = 'pc-chat-msg pc-chat-msg--bot pc-chat-msg--pending';

    var bubble = document.createElement('div');
    bubble.className = 'pc-chat-msg__bubble';

    var spinner = document.createElement('span');
    spinner.className = 'pc-chat-spinner';
    spinner.setAttribute('aria-hidden', 'true');

    var waitLabel = document.createElement('span');
    waitLabel.className = 'pc-chat-wait-label';
    waitLabel.textContent = 'Please wait...';

    var textEl = document.createElement('div');
    textEl.className = 'pc-chat-msg__text';

    bubble.appendChild(spinner);
    bubble.appendChild(waitLabel);
    bubble.appendChild(textEl);
    wrap.appendChild(bubble);
    messagesEl.appendChild(wrap);
    scrollBottom();

    return { wrap: wrap, textEl: textEl, rawMarkdown: '' };
  }

  function markBotHasText(wrap) {
    wrap.classList.add('pc-chat-msg--has-text');
  }

  function finishBotPending(wrap) {
    wrap.classList.remove('pc-chat-msg--pending');
  }

  function setInputDisabled(disabled) {
    loading = disabled;
    sendBtn.disabled = disabled;
    inputEl.disabled = disabled;
    presetBtns.forEach(function (btn) {
      btn.disabled = disabled;
    });
  }

  togglePanel(false);
  showWelcome();

  fab.addEventListener('click', function () {
    togglePanel(!isPanelOpen());
  });

  closeBtn.addEventListener('click', function () {
    togglePanel(false);
  });

  async function sendMessage(forcedText) {
    var text = (forcedText || inputEl.value || '').trim();
    if (!text || loading) return;

    hideWelcome();
    setInputDisabled(true);
    inputEl.value = '';

    if (activeAbort) {
      activeAbort.abort();
    }
    activeAbort = new AbortController();

    appendUserMessage(text);
    var bot = appendBotPending();

    try {
      var context = {
        shop_domain: SHOP_DOMAIN,
        page_url: window.location.href,
        locale: LOCALE
      };

      var response = await fetch(API_URL, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'text/event-stream',
          Authorization: 'Bearer ' + TOKEN
        },
        body: JSON.stringify({
          message: text,
          session_id: sessionId,
          visitor_id: visitorId,
          context: context
        }),
        signal: activeAbort.signal
      });

      if (!response.ok) {
        var errText = 'Request failed (' + response.status + ')';
        try {
          var errJson = await response.json();
          if (errJson.msg) errText = errJson.msg;
        } catch (e) {
          /* ignore */
        }
        throw new Error(errText);
      }

      var reader = response.body.getReader();
      var decoder = new TextDecoder();
      var buffer = '';
      var gotContent = false;

      while (true) {
        var chunk = await reader.read();
        if (chunk.done) break;

        buffer += decoder.decode(chunk.value, { stream: true });
        var lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (var i = 0; i < lines.length; i++) {
          var line = lines[i];
          if (line.indexOf('data: ') !== 0) continue;

          var dataStr = line.slice(6);
          if (dataStr === '[DONE]') continue;

          try {
            var data = JSON.parse(dataStr);

            if (data.error) {
              bot.rawMarkdown += (gotContent ? '\n' : '') + '[Error: ' + data.error + ']';
              renderBotMarkdown(bot.textEl, bot.rawMarkdown);
              gotContent = true;
              markBotHasText(bot.wrap);
              scrollBottom();
              continue;
            }

            var piece = data.content || '';
            if (piece) {
              bot.rawMarkdown += piece;
              renderBotMarkdown(bot.textEl, bot.rawMarkdown);
              gotContent = true;
              markBotHasText(bot.wrap);
              scrollBottom();
            }
          } catch (e) {
            /* ignore parse */
          }
        }
      }

      if (!gotContent) {
        setBotPlainText(bot, 'Sorry, no response. Please try again.');
      }
    } catch (err) {
      if (err.name === 'AbortError') {
        if (!bot.rawMarkdown) {
          setBotPlainText(bot, 'Cancelled.');
        }
      } else {
        setBotPlainText(bot, 'Sorry: ' + (err.message || 'unknown error'));
      }
    } finally {
      finishBotPending(bot.wrap);
      setInputDisabled(false);
      activeAbort = null;
      scrollBottom();
    }
  }

  window.PettiChatSupportAsk = function (message) {
    var text = (message || '').trim();
    if (!text) return false;
    togglePanel(true);
    sendMessage(text);
    return true;
  };

  sendBtn.addEventListener('click', function () {
    sendMessage();
  });

  inputEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  });

  presetBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var msg = btn.getAttribute('data-message') || btn.textContent.trim();
      sendMessage(msg);
    });
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChatWidget, { once: true });
  } else {
    initChatWidget();
  }
})();
